import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
    console.log("in err bdry")
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    console.log("in derived")
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    //logErrorToMyService(error, errorInfo);
    //console.log("catch!")
    typeof window !== "undefined" && window.gtag("event", "error", { category: "Errors", info: errorInfo, label: "error boundary", error: error, currentPageUrl: window.location.href})
 	//console.log("error-boundary", errorInfo) 
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <h1>Something went wrong.</h1>;
    }

    return this.props.children; 
  }
}